import HorizontalTabs, {
  HorizontalTabsProps,
} from 'src/components/Tab/HorizontalTabs';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

type DealDetailsTabsWrapperProps = {
  highlightedTabColor?: string;
  highlightedTabIndex?: number;
  tabs: HorizontalTabsProps['tabsData'];
};

export function DealDetailsTabsWrapper(
  props: Readonly<DealDetailsTabsWrapperProps>
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [selectedTab, setSelectedTab] = useState<string>(
    tabParam ?? props.tabs[0]?.tabValue?.toString()
  );
  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    if (newSearchParams.has('tab')) {
      newSearchParams.delete('tab');
      setSearchParams(newSearchParams);
    }
  };
  useEffect(() => {
    if (tabParam) {
      setSelectedTab(tabParam);
    }
  }, [tabParam]);

  return (
    <HorizontalTabs
      data-testid="gds-vp-ss-tabs"
      onTabChange={handleTabChange}
      tabsData={props.tabs}
      value={selectedTab}
    />
  );
}
